import { Injectable } from "@angular/core";
import Swal from "sweetalert2";
import { SessionUser } from "../shared/models/sessionUser";
import { TokenStorageService } from "./token-storage.service";
import { Router } from "@angular/router";

@Injectable({
	providedIn: "root",
})
export class VerificacionCertificadoService {
	public user: SessionUser;
	constructor(private tokenService: TokenStorageService, private router: Router) {}

	public validar(): Promise<boolean> {
		this.user = this.tokenService.getUser() as SessionUser;
		return new Promise((resolve) => {
			if (this.user.certificadoVigente === false) {
				Swal.fire({
					icon: "error",
					title: "Certificado Digital Vencido",
					text: "No tienes un certificado digital vigente. Por favor, actualizalo en el mantenedor de Certificados para habilitar la emisión documentos.",
					confirmButtonText: "Ok",
				}).then(() => {
					this.router.navigateByUrl("configuracion/certificados");
					resolve(false);
				});
			} else {
				resolve(true);
			}
		});
	}
}
